<div class="TeacherQuestionFlexQuestionCol">
  <h2 class="TeacherQuestionFlexHeading">
    <ng-container *ngIf="!questionTitleLayout">{{questionTitle}}</ng-container>

    <ng-container *ngTemplateOutlet="questionTitleLayout"></ng-container>
  </h2>
  <div class="TeacherQuestionPad">
    <kh-question-text *ngIf="!questionTextSubstituteLayout" [question]="question" [textProperty]="questionTextProperty" class="QuestionText QuestionTextTeacher"></kh-question-text>

    <ng-container *ngTemplateOutlet="questionTextSubstituteLayout"></ng-container>

    <ng-container *ngTemplateOutlet="afterQuestionTextLayout"></ng-container>
  </div>
</div>
<div class="TeacherQuestionFlexAnswersCol">
  <h2 class="TeacherQuestionFlexHeading">
    <ng-container *ngIf="!answersTitleLayout">
      <kh-tq-answers-header [answerType]="answerType" [manipulativeType]="manipulativeType" [class.question-with-remediation]="question.LogicalError || question.QuestionRationale">
      </kh-tq-answers-header>
    </ng-container>
    <ng-container *ngTemplateOutlet="answersTitleLayout"></ng-container>

    <ng-container *ngTemplateOutlet="answersTitleAdditionalContent"></ng-container>
  </h2>

  <ng-container *ngTemplateOutlet="preAnswersContent"></ng-container>

  <ng-container *ngIf="!choiceRowLayout">
    <ng-container *ngFor="let questionChoice of questionChoices">
      <div *ngIf="canShowChoice(questionChoice)" class="TeacherPreviewAnswerRow">
        <table>
          <tr>
            <td>
              <kh-tq-answer-content [choice]="questionChoice" [manipulativeType]="manipulativeType" [answerType]="answerType"></kh-tq-answer-content>
              <fa-icon *ngIf="isCorrectChoice(questionChoice)" [icon]="['fas', 'check']" class="light-green"></fa-icon>
            </td>
          </tr>
        </table>
      </div>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="choiceRowLayout">
    <ng-container *ngFor="let questionChoice of questionChoices; index as index">
      <ng-template [ngTemplateOutlet]="choiceRowLayout" [ngTemplateOutletContext]="{$implicit: questionChoice, index: index}"></ng-template>
    </ng-container>
  </ng-container>
</div>
